export const environment = {
  // BASE_URL: "http://103.235.105.93:8899/pos-api/api",
  BASE_URL: "https://demo.posdigits.com/pos-api/api",
  BASE_URL2: "https://demo.posdigits.com/pos-api/api",
}
